import store from '@/store';

export default function (route, to, from, next) {
    !store.getters['auth/isAuthenticated']
        ? next()
        : next(route);
}